import { render, staticRenderFns } from "./thirdPage.vue?vue&type=template&id=57104494&scoped=true"
import script from "./thirdPage.vue?vue&type=script&lang=js"
export * from "./thirdPage.vue?vue&type=script&lang=js"
import style0 from "./thirdPage.vue?vue&type=style&index=0&id=57104494&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57104494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ng-cash-center-h5-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57104494')) {
      api.createRecord('57104494', component.options)
    } else {
      api.reload('57104494', component.options)
    }
    module.hot.accept("./thirdPage.vue?vue&type=template&id=57104494&scoped=true", function () {
      api.rerender('57104494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/thirdPage.vue"
export default component.exports